import Store from '@/store'

export class DeployStoreUtils {

    static crossDeploy(data) {
        return Store.dispatch("deploy-store/crossDeploy", data);
    }

    static fethAssetUploadResult() {
        return Store.dispatch("deploy-store/fethAssetUploadResult");
    }

    static getAssetUploadResult() {
        return Store.getters["deploy-store/getAssetUploadResult"];
    }

    static getPendingForDeploy() {
        return Store.getters["deploy-store/getPendingForDeploy"];
    }
}